import axios from "axios";
import {axiosToApiError} from "../types/ApiError";
import {auth} from "../firebase";

export const upload = async (url: string, data: any): Promise<any> => {
    try {
        const authHeader = await auth.currentUser?.getIdToken();
        const apiHeaders = {Authorization: `Bearer ${authHeader}`}
        const response = await axios.put(url, data, {headers: apiHeaders});
        return response.data;
    } catch (error: any) {
        throw axiosToApiError(error);
    }
}